module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/text/text-height-7ca4560016d29851d7facabed9d7b44d.svg";